import type { OperationOutcome } from 'fhir/r4';

export function isOperationOutcome(response: unknown): response is OperationOutcome {
  if (typeof response === 'object' && response !== null) {
    return 'issue' in response;
  }
  return false;
}
